import React, { Component } from 'react';
import { Redirect,Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Moment from 'react-moment';
import {Row,Col,Form} from 'react-bootstrap';
 
import CustomMultiSelect from './helpers/customMultiSelect'; 
import {userGroupUrlCheck,getUserTimeZone} from '../../utils/userGroupUrlCheck';
import {URL_IMG} from '../../configs/urlConfigs';
import {ROUTE_REFRESH, ROUTE_AFFILIATE_REFRESH, ROUTE_CLIENT_REFRESH, LOGIN_AFFILIATE_GROUP, LOGIN_CLIENT_GROUP, USER_STATUS, USER_STATUS_PRIMARY,PHONE_ISD_CODE, PHONE_ISD_NUM} from '../../configs/staticConfigs'; 
import{  MSG_REQUIRED, MSG_CLIENT_ADD_SUCCESS, MSG_NOT_FOUND, MSG_LOGO_FORMAT, MSG_FILE_SIZE_ERROR, MSG_FILE_FORMAT_ERROR, MSG_ASS_USER_ADD_SUCCESS, MSG_ASS_USER_ADD_ERROR, MSG_ASS_USER_UPDATE_SUCCESS, MSG_ASS_USER_UPDATE_ERROR,  MSG_ASS_USER_DELETE_SUCCESS, MSG_ASS_USER_DELETE_ERROR,MSG_MAIL_RESEND,MSG_EMAIL_EXISTS_ERROR} from '../../configs/msgConfigs'; 
import { LBL_MUTE_EMAILS,LBL_MUTE_NOTICATIONS,LBL_APP_NAME, LBL_ASSOCIATE_USERS, LBL_ASSOCIATE_USER, LBL_BTN_ADDNEW, LBL_ADD, LBL_EDIT, LBL_DELETE,  LBL_CREATED_DATE_TIME, LBL_NAME, LBL_EMAIL, LBL_PHONE, LBL_ROLE, LBL_LAST_LOGIN, LBL_STATUS, LBL_FIRST_NAME, LBL_LAST_NAME, LBL_MOBILE_NUMBER, LBL_EMAIL_ADDRESS, LBL_RESEND_VERIFI_EMAIL, LBL_SELECT_ROLE, LBL_POSITION, LBL_DEPARTMENT, LBL_ACTIVE, LBL_SELECT_STATUS, LBL_USER_CREATED_ON, LBL_LAST_LOGGED_IN,LBL_MY_PROFILE,LBL_SELECT_All_DEPARTMENTS } from '../../configs/labelConfigs'; // LBL_CLIENT

import { assUserDeptListAction, assUserRolesListAction, assUserAddAction, assUserEditAction, assUserUpdateAction, associateUserDeleteAction } from '../../actions/assUserActions';

import {clearAction, resendEmailAction, assocUserDeactiveAction} from '../../actions/commonActions';

import * as types from '../../actions';
import {titleCase} from '../../utils/changeCase'; 
import {setStorage} from '../../utils/browserStorage'; 

import {converDateToLocal} from '../../utils/commonUtilities';
import {checkPermissions} from '../../utils/permissions';
import {validateEmail,imageExtension,fileSize} from '../../utils/validation'; // formValid 

import Toast from './helpers/toast';
import PhoneInput from 'react-phone-input-2';
import Cropper from 'react-easy-crop';
import 'react-easy-crop/react-easy-crop.css';
import getCroppedImg from '../commons/image-cropper/cropImage'
import ModalWindow from '../commons/helpers/modalWindow';

class AssociateAddEditComponent extends Component {

   constructor(props){
      super()

      this.state = {
         userGroup: 0, 
         departmentsList: [],
         rolesList: [],
         assocUsersAllData: [], 
         activeUserData: {
            profile_picture: '',
            profile_pic_url: '',
            first_name: '',
            last_name: '', 
            email: '', 
            mobile: '', 
            role: 0, 
            status: '1', 
            position: '',
            department: [],
            created_on: '',
            last_login: '',
            primary_contact:false,  
            mute_mails:false,  
            mute_pushs:false,  
         },   
         profilePictureAdded: 0, 
         isLogoValid: true, 
         logoLabel: MSG_LOGO_FORMAT, 
         activeUserId: 0, 
         activeUserProfileId: 0, 
         activeUserName: '', 
         assocUserActive: 0, 
         assocUserShown: 0, 
         clientId:'',   
         clientName:'', 
         toastMessagePop:'',
         toastFlagPop:false,
         toastSuccessPop:true, 
         searchString:'',
         formErrors:{
            profile_picture: '',
            first_name: "",
            last_name: "",
            email: "",
            mobile: "", 
            role: "", 
            status: '', 
            department: "",
         },
         deptMultiSelList: [],
         myProfileId: 0,
         image: '',
         crop: { x: 0, y: 0 },
         zoom: 1,
         aspect: 4 / 4,
         croppedArea:{},
         croppedAreaPixels:{},
         rotation:0,
         isClientPage:false
      } 

      this.openModal                = this.openModal.bind(this);
      this.onHandleChange           = this.onHandleChange.bind(this);
      this.onShowActionButtons      = this.onShowActionButtons.bind(this);
      this.onHideActionButtons      = this.onHideActionButtons.bind(this);
      this.resetActiveUser          = this.resetActiveUser.bind(this); 
      this.validateAddUser          = this.validateAddUser.bind(this); 
      this.onSaveFormData           = this.onSaveFormData.bind(this);
      this.loadMultiSelDeptValues   = this.loadMultiSelDeptValues.bind(this); 
      this.handleChangeMultiSel     = this.handleChangeMultiSel.bind(this); 

      this.modal        = React.createRef();
      this.modalDelete  = React.createRef();
      this.modalCropper = React.createRef();
   }

   resendEmail =(userId)=>{
      this.props.resendEmailAction(userId);
  }

   onHandleChange = (e) =>{
      // const {name,value}  = e.target;
      const {name}  = e.target;
      const value = e.target.type === "file" ? e.target.files[0] : e.target.type === "checkbox" ? e.target.checked : e.target.value;  
      let formErrors = this.state.formErrors;
  
      let activeUserData = this.state.activeUserData; 
      let isLogoValid = true;
      let profilePictureAdded = this.state.profilePictureAdded; 
      // let logoLabel = this.state.logoLabel; 
      formErrors.profile_picture = ''; 
      switch(name){
         case 'file_userProfile':
               if (!fileSize(value.size)) {
                  formErrors.profile_picture = MSG_FILE_SIZE_ERROR; 
                  isLogoValid = false;
                  profilePictureAdded = 0; 
               }
               else if(!imageExtension(value.name)){
                  formErrors.profile_picture = MSG_FILE_FORMAT_ERROR;
                  isLogoValid = false;
                  profilePictureAdded = 0; 
               }    
               else {
                  profilePictureAdded = 1; 
                  isLogoValid = true;
                  formErrors.profile_picture = ''; 
                  if(imageExtension(e.target.files[0].name)){
                     activeUserData.profile_pic_url = URL.createObjectURL(e.target.files[0]);
                     activeUserData.profile_picture = e.target.files[0]; // URL.createObjectURL(e.target.files[0]);
                  }
               }  
               break; 
         case 'txt_first_name': formErrors.first_name = value.trim()==='' ? MSG_REQUIRED : "";
            activeUserData.first_name = value; 
            break;  
         case 'txt_last_name': formErrors.last_name = value.trim()==='' ? MSG_REQUIRED : ""; 
            activeUserData.last_name = value; 
            break;       
         case 'txt_email':
               formErrors.email =  value.length <=0 || validateEmail(value) === false ? MSG_REQUIRED : "";
               activeUserData.email = value; 
               break;  
         case 'txt_mobile': formErrors.mobile = value.trim()==='' ? MSG_REQUIRED : ""; 
            activeUserData.mobile = value; 
            break;        
         case 'sel_role': formErrors.role = value===0 ? MSG_REQUIRED : ""; 
            activeUserData.role = value; 
            break;   
         case 'txt_position': activeUserData.position = value; 
            break; 
         case 'muteEmails': activeUserData.mute_mails = value; 
            break; 
         case 'muteNotifications': activeUserData.mute_pushs = value; 
            break;    
         case 'sel_status': formErrors.status = parseInt(value,10)===0 ? MSG_REQUIRED : ""; 
            activeUserData.status = value; 
            break;              
         default :
            break;
      }
      if(e.target.type=== "file"){
         let imgUrl = '';
         let imgObj = null;
         if(imageExtension(e.target.files[0].name)){
             imgObj = e.target.files[0]
             imgUrl = URL.createObjectURL(e.target.files[0]);
         }
         this.setState({imgUrl:imgUrl,imgObj:imgObj}, () => {
            document.getElementById('file_userProfile').value = '';
            this.openCropModal()
         });
         
     }

      this.setState({formErrors,activeUserData,isLogoValid,profilePictureAdded});
   }

   onPhoneInputChange = (value, data, event, formattedValue) =>{
      let activeUserData   = this.state.activeUserData;     
      let formErrors   = this.state.formErrors;     
      activeUserData['mobile'] = formattedValue;
      formErrors.mobile = value.trim()===data.dialCode ? MSG_REQUIRED : ""
      formErrors.mobile = formattedValue.trim().length<5 ? MSG_REQUIRED : ""
      this.setState({formErrors,activeUserData});
   }
   
   loadMultiSelDeptValues() {
      let allDept = []; 
      let activeDepartments = this.state.activeUserData.department;
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
         // let tmpObj = { value:'0', label:'Select All', selected:false; 
         this.state.departmentsList.forEach((item,index) => { 
            if(activeDepartments.includes(item.id)) tmpObj = {value:item.id, label:titleCase(item.name),  inputVal: item.id}; 
            else tmpObj = {value:item.id, label:titleCase(item.name)}; 
            
            allDept.push(tmpObj); 
         } ) 
         this.setState({deptMultiSelList:allDept}); 
      }
   }

   handleChangeMultiSel = (selectedDepts) =>{
      let actUserDept = []; 
      selectedDepts.forEach((item) => {
         actUserDept.push(item.value);
      });
      let actUserData = this.state.activeUserData; 
      actUserData.department = actUserDept; 

      let formErrors   = this.state.formErrors;     
      formErrors.department = actUserDept.length ? '' : MSG_REQUIRED; 
      this.setState({activeUserData:actUserData,formErrors}); 
  }

   onShowFilterBy = () => {
      this.setState(prevState => ({ isFilterOn: !prevState.isFilterOn }));
      document.getElementById("filterByMenu").classList.toggle('active');
      document.getElementById("filterIcon").classList.toggle('active');
   }

   onShowActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.toggle('show');
      dropdownMenu.classList.toggle('show');      

      if(this.state.activeRowId===0){   
         this.setState({activeRowId:rowId}); 
      }else if(this.state.activeRowId===rowId){ 
         this.setState({activeRowId:0}); 
      }else if(this.state.activeRowId!==rowId){   
         dropdown     = document.getElementById('dropdown-'+this.state.activeRowId);
         dropdownMenu = document.getElementById('dropdown-menu-'+this.state.activeRowId);
         dropdown.classList.toggle('show');
         dropdownMenu.classList.toggle('show');
         this.setState({activeRowId:rowId}); 
      }        
      
   }    

   onHideActionButtons = (event, rowId) =>{
      let dropdown     = document.getElementById('dropdown-'+rowId);
      let dropdownMenu = document.getElementById('dropdown-menu-'+rowId);
      dropdown.classList.remove('show');
      dropdownMenu.classList.remove('show');
      this.setState({activeRowId:0});
   }

   resetActiveUser() {
      let activeUserData = {
         profile_picture: '',
         profile_pic_url: '', 
         first_name: '',
         last_name: '', 
         email: '', 
         mobile: '', 
         role: 0, 
         status: '1', 
         position: '',
         department: [],
         primary_contact:false 
      };   
      let allDept = []; 
      if(this.state.departmentsList.length > 0) {
         let tmpObj = {}; 
      
         this.state.departmentsList.forEach((item,index) => { 
            tmpObj = {value:item.id, label:titleCase(item.name)}; 
            allDept.push(tmpObj); 
         } ) 
      }
      this.setState({activeUserData:activeUserData, isLogoValid:true, activeUserId:0, activeUserProfileId:0, activeUserName:'', deptMultiSelList:allDept,imgUrl:''}); 
   }

   openModal(e,userId) {
      if(!userId || userId===0) this.resetActiveUser(); 
      this.resetFormErrors();
      this.modal.current.handleOpenModal();
   }      

   deleteBtnClick = (rowId,name) =>{
      this.setState({
         activeUserId:rowId,
         activeUserName:name          
      }); 
      this.modalDelete.current.handleOpenModal();
      this.modal.current.handleModelCloseOnly();     
   }

   onDeleteAction = () =>{
      let activeUserId = this.state.activeUserId;
      this.props.associateUserDeleteAction(activeUserId);
      this.modalDelete.current.handleModelClose();  
      this.modal.current.handleModelClose();                          
   } 

   deletePopup = () => {
      let fullName = this.state.activeUserData.first_name+' '+this.state.activeUserData.last_name; 
      this.deleteBtnClick(this.state.activeUserId,fullName); 
   }

   resetFormErrors=()=>{
      let formErrors = {
         profile_picture: '',
         first_name: '',
         last_name: '', 
         email: '', 
         mobile: '', 
         role: 0, 
         status: '', 
         department: ''
      };   
      this.setState({formErrors});  
   }

   validateAddUser() {
      let formErrors = this.state.formErrors;
      let activeUserData = this.state.activeUserData; 
      let picURL = activeUserData.profile_picture; 
      let isLogoValid = this.state.isLogoValid;
      let logoLabel = this.state.logoLabel; 
      let foundIssue = 0; 
      let profilePictureAdded = this.state.profilePictureAdded; 
      if (profilePictureAdded > 0 && picURL!=='') {
         if(!fileSize(picURL.size)) { logoLabel = MSG_FILE_SIZE_ERROR; isLogoValid = false; foundIssue = 1; }
         else if(!imageExtension(picURL.name)){ logoLabel = MSG_FILE_FORMAT_ERROR; isLogoValid = false; foundIssue = 1; }    
      }
      if(activeUserData.first_name.trim()==='') {
         formErrors.first_name = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.last_name.trim()==='') {
         formErrors.last_name = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.email.trim()==='' || validateEmail(activeUserData.email) === false) {
         formErrors.email = MSG_REQUIRED; foundIssue = 1;
      }
      if(activeUserData.mobile.trim()==='') {
         formErrors.mobile = MSG_REQUIRED; foundIssue = 1;
      }
      if(this.state.userGroup===LOGIN_AFFILIATE_GROUP && !activeUserData.department.length && !this.state.isClientPage) {
         formErrors.department = MSG_REQUIRED; foundIssue = 1;
      }
      if(parseInt(activeUserData.role,10)===0) {
         formErrors.role = MSG_REQUIRED; foundIssue = 1;
      }
      if(parseInt(activeUserData.status,10)===0) { 
         formErrors.status = MSG_REQUIRED; foundIssue = 1;
      }

      this.setState({formErrors,activeUserData,isLogoValid,logoLabel}); 
         
      if(foundIssue===0) {
         return true; 
      }
      else {
         return false; 
      }
   }

   onSaveFormData = (e) =>{
      e.preventDefault();
      if(this.validateAddUser()){ 
         const activeUserId = this.state.activeUserId; 
         const data         = new FormData(); 
         const userData     = this.state.activeUserData;

         let deptData       = userData.department.join(','); 
         
         // IF ALL DEPARTMENTS ARE SELECTED, PASS THE FLAG DATA 'all' ALSO IN THE department ARRAY
         if(this.state.departmentsList.length===userData.department.length) deptData += ',all'; 

         data.append('assUserId', activeUserId);
         if(this.state.profilePictureAdded > 0) data.append('profile_picture', userData.profile_picture); 
         data.append('first_name', userData.first_name);
         data.append('last_name', userData.last_name);
         data.append('email', userData.email);
         data.append('mobile', userData.mobile);
         data.append('role', userData.role);
         data.append('status', userData.status);
         data.append('position', userData.position);
         // data.append('department', userData.department.join(',')); 
         data.append('department', deptData); 
         data.append('mute_pushs', userData.mute_pushs); 
         data.append('mute_mails', userData.mute_mails); 
         if(activeUserId > 0){
            data.append('send_mail', "0");
            this.props.assUserUpdateAction(data); ;
         }else{
            this.props.assUserAddAction(data); 
         }  
      }
      else {
         return false; 
      }
   }

   onModalFormReset = () =>{       
      this.setState({ activeUserId:0, activeUserProfileId:0, activeUserName:'' }); 
   }
   
   onCloseToast = () =>{
      this.setState({toastFlagPop:false,toastMessagePop:'',toastSuccessPop:false});
   } 

   onsearchString = (e)=>{
      this.setState({searchString:e.target.value})
      this.props.assUserListAction({pageSize:this.state.perPageCount,page:this.state.activePage,column:this.state.sortOrder+this.state.sortField,search:e.target.value});
   }

   setToasterState(isEnabled,message,isSucces,isAutoHide=true){
      this.setState({toastFlagPop:isEnabled,toastMessagePop:message,toastSuccessPop:isSucces});
      if(isAutoHide){
          setTimeout(()=> {
              this.onCloseToast();
          }, 3000);
      }
      // else{
      //     setTimeout(()=> {
      //         this.onCloseToast();
      //     }, 10000000000000);
      // }      
   }

   openCropModal =() =>{
        this.modalCropper.current.handleOpenModal();
   }

   onCropChange = crop => {
        this.setState({ crop })
   }
 
   onCropComplete = (croppedArea, croppedAreaPixels) => {
        this.setState({croppedArea:croppedArea,croppedAreaPixels:croppedAreaPixels})
   }
 
   onZoomChange = zoom => {
        this.setState({ zoom })
   }



   setCroppedImage(){
        this.modalCropper.current.handleModelClose();
    }
    
    cropImage(e){
        let {imgObj,croppedAreaPixels,rotation,imgUrl} = this.state
        const obj = this;
        let canvas = getCroppedImg(
            imgObj,
            croppedAreaPixels,
            obj,
            rotation,
            'affiliateAsso'
        )

    }


   componentDidUpdate(prevProps) {
      const {numRows,totalPage,activity,errorData,status,subactivity,assocUserActive,departmentsList,rolesList,assocUserDeptStatus,assocUserDeptActivity,assocUserRolesStatus,assocUserRolesActivity, assocUserAddStatus, assocUserAddActivity,activeUserId,activeUserProfileId,assocUserData,assocUserGetStatus,assocUserGetActivity,assocUserUpdateData} = this.props;   
      
      if(Number(activeUserId) > 0 && Number(activeUserId)!==Number(this.state.activeUserId)) {
         this.setState({activeUserId:activeUserId,activeUserProfileId:activeUserProfileId});  
         this.props.assUserEditAction(activeUserId); 
      }

      // if (assocUserActive !== prevProps.assocUserActive && Number(assocUserActive) && this.state.assocUserShown > 0) {
      //    this.editBtnClick('',assocUserActive);    
      //    this.props.assocUserDeactiveAction(0); 
      // }

      if (assocUserGetActivity && (assocUserGetStatus !== prevProps.assocUserGetStatus || assocUserGetActivity!==prevProps.assocUserGetActivity)) {
         var arrRespGet = assocUserGetActivity.split('~~'); 
         if(arrRespGet[0]===types.ASS_USER_EDIT_SUCCESS) { 
            if(assocUserGetStatus===200) {
               let rObj = assocUserData; 
               let pic = rObj.profile_picture; 
               if(pic && pic.length > 4 && pic.substring(pic.length-4)==='null') pic = ''; 
               // primary_contact: rObj.primary_contact,  last_login: rObj.user.last_login,
               if(pic === 'null' || pic === null) pic = '';
               let activeUserData =  {
                     profile_picture: pic,
                     profile_pic_url: pic,
                     first_name: rObj.first_name,
                     last_name: rObj.last_name,
                     email: rObj.email,
                     mobile: rObj.mobile, 
                     role: rObj.role, 
                     status: rObj.status.toString(),
                     position: rObj.position,
                     department: rObj.department,
                     created_on: rObj.created_on,
                     last_login: rObj.last_login,
                     email_verified: rObj.email_verified,
                     primary_contact: rObj.primary_contact,  
                     mute_mails: rObj.mute_mails,  
                     mute_pushs: rObj.mute_pushs  
                  }
               let allDept = []; 
               if(this.state.departmentsList.length > 0) {
                  this.state.departmentsList.forEach((item,index) => { 
                     if(rObj.department.includes(item.id)) allDept.push({value:item.id, label:titleCase(item.name), inputVal: item.id}); 
                     else allDept.push({value:item.id, label:titleCase(item.name)}); 
                  } ) 
               }
              this.setState({
                 activeUserData:activeUserData, 
                 isLogoValid:true, 
                 profilePictureAdded:0,  
                 deptMultiSelList:allDept,
                 formErrors:{
                  profile_picture: '',
                  first_name: '',
                  last_name: '',
                  email: '',
                  mobile: '', 
                  role: 1, 
                  status: '', 
                  department: '',
               },
               });
            }
         }
      }

      if (assocUserDeptActivity && (assocUserDeptStatus !== prevProps.assocUserDeptStatus || assocUserDeptActivity!==prevProps.assocUserDeptActivity)) {
         var arrRespDept = assocUserDeptActivity.split('~~'); 
         var actStringDept = arrRespDept[0]; 
         if(actStringDept===types.DEPARTMENT_LIST_ASSOC_USER_SUCCESS) {  
            if(this.props.hasOwnProperty('departmentsList')) {
               if(this.props.departmentsList.length===0) {
                     this.setState({departmentsList: []}, () => {
                        this.loadMultiSelDeptValues(); 
                     } ); 
               }
               else {     
                     this.setState({departmentsList: this.props.departmentsList}, () => {
                        this.loadMultiSelDeptValues(); 
                     } );                  
               }
            }
         } 
      }

      if (assocUserRolesActivity && (assocUserRolesStatus !== prevProps.assocUserRolesStatus || assocUserRolesActivity!==prevProps.assocUserRolesActivity)) {
         var arrRespRoles = assocUserRolesActivity.split('~~'); 
         var actStringRoles = arrRespRoles[0]; 
         if(actStringRoles===types.ROLES_LIST_ASSOC_USER_SUCCESS) { 
            if(this.props.hasOwnProperty('rolesList')) {
               if(this.props.rolesList.length===0) {
                     this.setState({rolesList: []}); 
               }
               else {     
                     this.setState({rolesList: this.props.rolesList});                  
               }
            }
         }
      }

      if (assocUserAddActivity && (assocUserAddStatus !== prevProps.assocUserAddStatus || assocUserAddActivity!==prevProps.assocUserAddActivity)) {
         var arrRespAdd = assocUserAddActivity.split('~~'); 
         var actStringAdd = arrRespAdd[0]; 

         if(actStringAdd===types.ASS_USER_ADD_SUCCESS) { 
            if(assocUserAddStatus===200) {
               if(this.props.calledFrom && this.props.calledFrom==='associates') {
                  this.resetActiveUser(); 
                  this.props.onAssocUserAddSuccess(); 
               }
               else {
                  this.setState({toastSuccessPop:true, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_ADD_SUCCESS});
                  setTimeout(()=> { this.onCloseToast(); }, 4000);
               }
            }
            else {
               console.log(this.props.errorData); 
               let errorMsg = '';  
               if(assocUserAddStatus===400)  errorMsg = ' - '+MSG_EMAIL_EXISTS_ERROR;  
               this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_ADD_ERROR+errorMsg});
            } 
         } 
         else if(actStringAdd===types.ASS_USER_ADD_ERROR) { 
            console.log(this.props.errorData); 
            let errorMsg = '';  
            if(assocUserAddStatus===400)  errorMsg = ' - '+MSG_EMAIL_EXISTS_ERROR;  
            this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_ADD_ERROR+errorMsg});
         }
         else if(actStringAdd===types.ASS_USER_UPDATE_SUCCESS) { 
            if(assocUserAddStatus===200) {
               
               // SET NEW PROFILE PICTURE AND AVATAR NAME TO STORE 
               if(assocUserUpdateData.profile_picture) {
                  let userGroupData = userGroupUrlCheck(window.location);
                  if(userGroupData!==undefined && userGroupData.user_group && userGroupData.user_group===LOGIN_AFFILIATE_GROUP){
                     userGroupData.profile_img = assocUserUpdateData.profile_picture;
                     if(assocUserUpdateData.avatar_name) userGroupData.avatar_name = assocUserUpdateData.avatar_name; 
                     if(assocUserUpdateData.name) userGroupData.profilename = assocUserUpdateData.name; 
                     
                     setStorage('affiliate', JSON.stringify(userGroupData));
                  }
               }

               if(this.props.calledFrom && this.props.calledFrom==='associates') {
                  this.resetActiveUser(); 
                  this.props.onAssocUserUpdateSuccess(); 
               }
               else {
                  this.setState({toastSuccessPop:true, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_UPDATE_SUCCESS});
                  setTimeout(()=> { this.onCloseToast(); }, 4000);
                  
               }
               if(this.props.calledFrom && this.props.calledFrom==='profile') { 
                  setTimeout(()=> { this.props.closeMyProfile(); }, 1500); 
               }
            }
            else {
               console.log(this.props.errorData); 
               let errorMsg = '';  
               if(assocUserAddStatus===400)  errorMsg = ' - '+MSG_EMAIL_EXISTS_ERROR;  
               this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_UPDATE_ERROR+errorMsg});
            } 
         }
         else if(actStringAdd===types.ASS_USER_UPDATE_ERROR) { 
            console.log(this.props.errorData); 
               let errorMsg = '';  
               if(assocUserAddStatus===400)  errorMsg = ' - '+MSG_EMAIL_EXISTS_ERROR;  
               this.setState({toastSuccessPop:false, toastFlagPop:true, toastMessagePop:MSG_ASS_USER_UPDATE_ERROR+errorMsg});
         } 
      }


      if ((status !== prevProps.status || activity!==prevProps.activity)) {
         if(activity===types.RESEND_EMAIL_SUCCESS){
            this.setToasterState(true,MSG_MAIL_RESEND,true,false);
         }else if(activity===types.RESEND_EMAIL_ERROR){
            this.setToasterState(true,JSON.stringify(errorData),false);
         } 
      }
   }

   componentDidMount() {
      const { location } = this.props;
      let userGroupData = userGroupUrlCheck(location);
      let userGroup = ''; 
      let myProfileId = 0; 
      if(userGroupData!==undefined){
         userGroup = userGroupData.user_group; 
         myProfileId = userGroupData.associate_id; 
      }   
      if(userGroup===LOGIN_AFFILIATE_GROUP){
         document.body.classList.add('body-affiliate'); 
      }else if(userGroup===LOGIN_CLIENT_GROUP){
         document.body.classList.add('body-client');
         this.setState({isClientPage:true}) 
      }
      // document.title = LBL_APP_NAME+" - "+LBL_ASSOCIATE_USERS;
      this.props.assUserDeptListAction(); 
      this.props.assUserRolesListAction(); 
      this.setState({userGroup:userGroup,myProfileId:myProfileId}); 
   }
   
   uploadProfileFile() {
      document.getElementById('file_userProfile').click(); 
   } 
   
   render(){

        const { activePage,startIndex,endIndex,toastMessagePop,toastFlagPop,toastSuccessPop,myProfileId,activeUserProfileId,imgUrl } = this.state; 
        let formErrors      = this.state.formErrors;
        const {totalPage,status} = this.props;   
        let assocUsersAllData = {}; 
                
        if(this.props.hasOwnProperty('assocUsersAllData')) assocUsersAllData = this.props.assocUsersAllData;   
            
        let userGroupData = userGroupUrlCheck(this.props.location);
        let userGroup = ''; 
        if(userGroupData!==undefined){
            userGroup = userGroupData.user_group; 
        }

        if(status===401 || status===403){
            if(userGroup===LOGIN_AFFILIATE_GROUP){
               return <Redirect to={ROUTE_AFFILIATE_REFRESH} />;
            } else if(userGroup===LOGIN_CLIENT_GROUP){
               return <Redirect to={ROUTE_CLIENT_REFRESH} />;
            } else{
               return <Redirect to={ROUTE_REFRESH} />;
            }
        }
        let logoUrl = require('../../'+URL_IMG+'profile-image.png');
        
        let isLogoValid = this.state.isLogoValid; 
        let activeUserData = this.state.activeUserData; 
        let logoLabel = this.state.logoLabel; 
        if(this.state.activeUserData.hasOwnProperty('profile_pic_url') && this.state.activeUserData.profile_pic_url){
            logoUrl = this.state.activeUserData.profile_pic_url;
        }

        if(imgUrl){
            logoUrl = imgUrl;
        } 
        let rolesList = this.state.rolesList; 
        let showDeleteLinkLeft = (this.state.activeUserId > 0 && !this.state.activeUserData.primary_contact) ? 'yes' : ''; 

        let timeZone =  getUserTimeZone(window.location); 
        let created_on = activeUserData.created_on && activeUserData.created_on.length > 1 ? converDateToLocal(activeUserData.created_on,"+00:00",'ddmmyyyyhhmm') : '';   
        let last_login = activeUserData.last_login && activeUserData.last_login.length > 1 ? converDateToLocal(activeUserData.last_login,"+00:00",'ddmmyyyyhhmm') : '';  

        let arrUserStatus = activeUserData.primary_contact ? USER_STATUS_PRIMARY : USER_STATUS; 
        let isAffiliateCanDepartment = !checkPermissions("assodepartment","modify");
        return(
            <React.Fragment>
            <div className="col-md-12">
                  <Form id="form_dataEntry" onSubmit={(e) => this.onSaveFormData(e)} encType="multipart/form-data">
                     <Form.Group>
                     <Toast toastDescription={toastMessagePop} toastFlag={toastFlagPop} toastSuccess={toastSuccessPop} closeToast={this.onCloseToast} />
                        <Row>
                           <div className="col-md-12 text-center">
                              <div className="company-logo">
                                 <img src={logoUrl} alt="Profile Name" style={{cursor:'pointer'}} onClick={this.uploadProfileFile} />  
                                 <p className={isLogoValid?'logo-txt':'text-red logo-txt'}>
                                    <small>{logoLabel}</small>
                                    { (formErrors.profile_picture.length > 0) && 
                                       <div><small>{formErrors.profile_picture}</small></div>
                                    }
                                 </p>                                          
                                 <label htmlFor="file_userProfile"><i className="las la-pen"></i></label> 
                                 <input type="file" id="file_userProfile" name="file_userProfile" onChange={this.onHandleChange} accept=".jpeg, .jpg, .png, .gif"/>                                          
                              </div>
                           </div>
                        </Row>
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                 <label>{LBL_FIRST_NAME} </label>
                                    <div className="text-input"><input type="text" name="txt_first_name" id="txt_first_name" onChange={this.onHandleChange} className={formErrors.first_name.length >0 ? "input-error" : ''} value={activeUserData.first_name || ''} maxLength="30" tabIndex="1" autoFocus={true} /></div>
                              </div>
                           </Col>   
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_LAST_NAME}</label>
                                    <div className="text-input"><input type="text" className={formErrors.last_name.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="txt_last_name" value={activeUserData.last_name || ''}  maxLength="30" tabIndex="2" /></div>
                              </div>
                           </Col>
                        </Row>
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_MOBILE_NUMBER}</label>
                                    <div className={formErrors.mobile.length>0?'input-error':''}>
                                      <PhoneInput 
                                        country={PHONE_ISD_CODE}
                                        inputProps={{
                                          name: 'txt_mobile',
                                          tabIndex: "3",
                                        }}
                                        value={activeUserData.mobile || PHONE_ISD_NUM}
                                        onChange={this.onPhoneInputChange} 
                                      />
                                   </div>
                              </div>
                           </Col>     
                           <Col md={6}>
                              <div className="form-group"> 
                                    <label>{LBL_EMAIL_ADDRESS}</label>
                                    <div className="input email-input"><input type="email" className={formErrors.email.length >0 ? "input-error" : ''} onChange={this.onHandleChange} name="txt_email" value={activeUserData.email || ''}  maxLength="120" tabIndex="4" />
                                    {formErrors.email.length >0 && formErrors.email!==MSG_REQUIRED && (
                                       <div className="text-red left-align text-12">{formErrors.email}</div>
                                    )} 
                                    <small className="text-red">{activeUserData.email_verified===false && activeUserData.email?'Not Verified':''}</small><Link className={activeUserData.email_verified===false&&activeUserData.email?'resend-btn float-right':'hide'} to="#" onClick={e => this.resendEmail(this.state.activeUserId)} tabIndex="5">{LBL_RESEND_VERIFI_EMAIL}</Link>
                                    </div>
                              </div>
                           </Col>
                        </Row> 
                        
                        <Row>
                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_ROLE}</label>
                                    <div className="form-group select-input">
                                    <select name="sel_role" value={activeUserData.role} className={formErrors.role.length ? "input-error" : ''} onChange={this.onHandleChange} tabIndex="6" disabled={this.props.fromEdit?'':true} >
                                       <option value='0'>{LBL_SELECT_ROLE}</option>
                                       {rolesList.map((item,index) => { return (
                                       <option key={item.id} value={item.id} >{titleCase(item.name)}</option> )
                                       } ) } 
                                       {/* if(item.name.trim().toLowerCase()!=='admin') */}
                                    </select>
                                 </div>
                              </div>
                           </Col> 
                           <Col md={6}>
                              <div className="form-group"> 
                                    <label>{LBL_POSITION}</label>
                                    <div className="input-input"><input type="text" onChange={this.onHandleChange} name="txt_position" value={activeUserData.position || ''}  maxLength="120" tabIndex="7" /></div>
                              </div>
                           </Col>
                        </Row>
                        
                        <Row>
                           { (this.state.userGroup===LOGIN_AFFILIATE_GROUP) && <Col md={6}>
                              <div className="form-group">
                                 <label>{LBL_DEPARTMENT}</label>
                                 <div className="form-group multisel_textbox">
                                    <div className="form-group select-input skills" >
                                       <CustomMultiSelect id={'dept'} data={this.state.deptMultiSelList}  onChange={selected =>this.handleChangeMultiSel(selected)} isTextBox={false} isDisable={isAffiliateCanDepartment} needSelectAll={true} selectAllText={LBL_SELECT_All_DEPARTMENTS} classValue={formErrors.department.length ? "input-error" : ''} /> 
                                       {/*  */}
                                    </div>
                                 </div>                                 
                              </div>
                           </Col>
                           } 

                           <Col md={6}>
                              <div className="form-group">
                                    <label>{LBL_STATUS}</label>
                                    <div className="form-group select-input">
                                    <select name="sel_status" value={activeUserData.status} onChange={this.onHandleChange} className={formErrors.status.length ? "input-error" : ''} disabled={Number(activeUserProfileId) > 0 && Number(activeUserProfileId)===Number(myProfileId)} tabIndex="9">
                                       { (this.state.activeUserId===0) && 
                                          <option value='1'>{LBL_ACTIVE}</option>
                                       }
                                       { (this.state.activeUserId > 0) && 
                                          <option value='0'>{LBL_SELECT_STATUS}</option>
                                       }
                                       {(this.state.activeUserId > 0) && arrUserStatus.map((item,index) => { return (
                                       <option key={item.statusCode} value={item.statusCode} >{titleCase(item.statusString)}</option> )
                                       } ) }  
                                    </select>
                                    
                                 </div>
                              </div>
                           </Col>
                        </Row>
                        <Row>
                           <Col md={6}>
                              <div className="custom-checkbox"><input type="checkbox" id="muteEmails" name="muteEmails" onChange={this.onHandleChange} checked={this.state.activeUserData.mute_mails}/><label className="checkbox" htmlFor="muteEmails"></label><label className="labeltext" htmlFor="muteEmails">{LBL_MUTE_EMAILS}</label></div>
                           </Col>
                           <Col md={6}>
                              <div className="custom-checkbox"><input type="checkbox" id="muteNotifications" name="muteNotifications" onChange={this.onHandleChange} checked={this.state.activeUserData.mute_pushs}/><label className="checkbox" htmlFor="muteNotifications"></label><label className="labeltext" htmlFor="muteNotifications">{LBL_MUTE_NOTICATIONS}</label></div>
                           </Col>
                        </Row>


                        { (this.state.activeUserId > 0) && 
                        <Row>  
                           <Col md={6}> 
                              <div className="form-group">
                                 <label><span>{LBL_USER_CREATED_ON} :<strong> {created_on}</strong></span></label> 
                                    {/* { activeUserData.created_on && (activeUserData.created_on.length > 0) && (activeUserData.created_on!==null) && <Moment format="DD/MM/YYYY HH:mm">{activeUserData.created_on}</Moment>}*/} 
                              </div>
                           </Col>
                           <Col md={6}>
                              <div className="form-group">
                                 <label><span>{LBL_LAST_LOGGED_IN} :<strong> {last_login}</strong></span></label>
                                    {/* { activeUserData.last_login && (activeUserData.last_login.length > 0) && (activeUserData.last_login!==null) && <Moment format="DD/MM/YYYY HH:mm">{activeUserData.last_login}</Moment>} 
                                    {/*Mar 1, 2020 11:10 PM */}   
                              </div>
                           </Col>
                        </Row> }  
                        
                     </Form.Group>
                  </Form>
               <ModalWindow ref={this.modalCropper} type="imageCropper" saveFormData={ (e)=>this.cropImage(e)}>
                  <Cropper
                       image={logoUrl}
                       crop={this.state.crop}
                       zoom={this.state.zoom}
                       aspect={this.state.aspect}
                       onCropChange={this.onCropChange}
                       onCropComplete={this.onCropComplete}
                       onZoomChange={this.onZoomChange}
                  />
               </ModalWindow>                             
            </div>
         </React.Fragment>
        )
    }
}

const mapStateToProps = (state) => {
   return {
      status:state.assocUsers.status,
      statusText:state.assocUsers.statusText,
      activity:state.assocUsers.activity,
      assocUserDeptStatus:state.assocUsers.assocUserDeptStatus,
      assocUserDeptActivity:state.assocUsers.assocUserDeptActivity,
      assocUserRolesStatus:state.assocUsers.assocUserRolesStatus,
      assocUserRolesActivity:state.assocUsers.assocUserRolesActivity,
      assocUserAddStatus: state.assocUsers.assocUserAddStatus,
      assocUserAddActivity: state.assocUsers.assocUserAddActivity,
      assocUserData: state.assocUsers.assocUserData,
      assocUserUpdateData: state.assocUsers.assocUserUpdateData, 
      assocUserGetStatus: state.assocUsers.assocUserGetStatus,
      assocUserGetActivity: state.assocUsers.assocUserGetActivity,
      subactivity:state.assocUsers.subactivity,  
      assocUsersAllData: state.assocUsers.assocUsersAllData,
      departmentsList : state.assocUsers.departmentsList,
      rolesList : state.assocUsers.rolesList,
      errorData:state.assocUsers.errorData,
      isFilterOn: state.commons.isFilterOn,   
      assocUserActive: state.commons.assocUserActive
   }
};

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({
         assUserDeptListAction:assUserDeptListAction, 
         assUserRolesListAction:assUserRolesListAction, 
         assUserAddAction:assUserAddAction,
         assUserEditAction:assUserEditAction, 
         assUserUpdateAction:assUserUpdateAction, 
         resendEmailAction:resendEmailAction,
         assocUserDeactiveAction:assocUserDeactiveAction,
         clearAction:clearAction,
    },dispatch);
}
export default connect(mapStateToProps,mapDispatchToProps)(AssociateAddEditComponent);